import * as Yup from 'yup';

export const subscriptionFileUploadSchema = Yup.object().shape({
    fileTypeId: Yup.string()
        .required('Required'),
});
